import React, { useState, useContext, useCallback } from 'react'
import { Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';
import { MessageContext } from './Contexts'
import { UploadLogo, ResetLogo } from 'modules/Rest'
import { format } from 'date-fns'
import { ControlledActionButton } from './ActionButtons'
import { setModes } from 'modules/Utils'
import { useSelectedDataRoom } from 'hooks/useSelectedDataRoom'

const useStyles = makeStyles(theme => ({
  logo: {
    height: 50,
  },
  form: {
    paddingBottom: 10,
  },
}))

function DataRoomLogoCard() {
  const classes = useStyles()
  const { dataRoom: {data_room} } = useSelectedDataRoom()
  const { messageDispatch } = useContext(MessageContext)
  const [uploadDate, setUploadDate] = useState(new Date())

  const [modeUpload, setModeUpload] = useState('')
  const [modeReset, setModeReset] = useState('')

  const upload = useCallback(async event => {
    if (event.target.files[0]) {
      try {
        setModeUpload('pending')
        const target = event.target
        await UploadLogo({data_room, file: event.target.files[0]})
        target.value = ""
        await setModes(setModeUpload, ['completing', 1500, ''])
        setUploadDate(new Date())
      } catch (error) {
        setModeUpload('')
        messageDispatch({ type: 'warning', payload: error.message })
      }
    }
  }, [data_room, messageDispatch])

  const reset = useCallback(async () => {
    try {
      setModeReset('pending')
      await ResetLogo({ data_room })
      setUploadDate(new Date())
      await setModes(setModeReset, ['completing', 1500, ''])
    } catch (error) {
      setModeReset('')
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [data_room, messageDispatch])

  return (
    <>
      <Typography variant='subtitle1'>
        Logotype
      </Typography>

      <form noValidate autoComplete='off' className={classes.form}>
        <img
          src={`/logo?data_room=${data_room}&height=94&time=${format(
            uploadDate,
            'T'
          )}&no_logo_show=true`}
          alt='logotype'
          className={classes.logo}
        />
        <Grid container>
          <Grid item>
            <label>
              <input
                accept='image/*'
                style={{display: 'none'}}
                type='file'
                onChange={e => upload(e)}
              />
              <ControlledActionButton
                mode={modeUpload}
                setMode={setModeUpload}
                actionTitle='Upload logo'
                buttonParams={{component: 'span', className: classes.button}}
              />
            </label>
          </Grid>
          <Grid item>
              <ControlledActionButton
                mode={modeReset}
                setMode={setModeReset}
                action={reset}
                actionTitle='Standard logo'
                buttonParams={{component: 'span', className: classes.button}}
              />
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default DataRoomLogoCard
